export default __webpack_public_path__ + "static/media/darkSwap.ebf1710e.png";